//auth.js
import axios from "axios";

import { setHeaderToken } from "../utils/auth";
import { removeHeaderToken } from "../utils/auth";

import firebase from "firebase/app";

export default {
  state: {
    userId: "",
    countChat: 0,
    user: "",
    order: [],
    notif: [],
    isLoggedIn: false,
    isConReady: false,
    errorState: "",
  },
  mutations: {
    set_user(state, data) {
      state.user = data;
      state.isLoggedIn = true;
      state.isConReady = true;
    },

    set_notif(state, data) {
      state.notif = data;
      state.isLoggedIn = true;
    },
    set_order(state, data) {
      state.order = data;
      state.isLoggedIn = true;
    },
    reset_user(state) {
      state.user = null;
      state.isLoggedIn = false;
      state.isConReady = false;
    },
    set_get_count_chat(state, data) {
      state.countChat = data;
    },
    increment(state) {
      state.countChat++;
    },
  },
  getters: {
    isLoggedIn(state) {
      return state.isLoggedIn;
    },
    user(state) {
      return state.user;
    },
    order(state) {
      return state.order;
    },
    countChat(state) {
      return state.countChat;
    },
    notif(state) {
      return state.notif;
    },
    isConReady(state) {
      return state.isConReady;
    },
  },
  actions: {
    increment({ commit }) {
      commit("increment");
    },
    login({ dispatch, commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post("user/login/seller", data)
          .then((response) => {
            if (response.data.status.code == 400) {
              localStorage.removeItem("token");
              commit("reset_user");
              // console.log(response.data.status.message);
              return response.data.status;
            } else {
              return response;
            }
          })
          .then((response) => {
            if (response.code == 400) {
              const error = new Error(response);
              error.response = response;
              throw response;
            }
            const token = response.data.data;

            localStorage.setItem("token", token);
            setHeaderToken(token);
            dispatch("get_order");
            dispatch("get_notif");
            dispatch("get_user");
            dispatch("get_count_chat");

            resolve(response);
          })
          .catch((error) => {
            commit("reset_user");
            // localStorage.removeItem("token");
            // console.log(error);
            reject(error);
          });
      });
    },
    //countOrder

    async get_count_chat({ commit }) {
      firebase
        .database()
        .ref(`/unread-message/seller/${this.state.userId}`)
        .on("value", () => {
          try {
            fetch(
              `https://siplah.eurekabookhouse.co.id/api_chat/get-unread-message?from=customer&id=${this.state.userId}`
            )
              .then((data) => {
                return data.json();
              })
              .then((res) => {
                commit("set_get_count_chat", res.total_unread);
                this.state.countChat = res.total_unread;
              })
              .catch(() => {});
          } catch (error) {
            return error;
          }
        });

      // fetch(
      //   `https://siplah.eurekabookhouse.co.id/api_chat/get-users?id=${this.state.userId}&from=seller`
      // )
      //   .then((res) => {
      //     return res.json();
      //   })
      //   .then((data) => {
      //     commit("set_get_count_chat", data[0].countUnread);
      //     this.state.countChat = data[0].countUnread;
      //     console.log('state', this.state.countChat)
      //   })

      // socket.emit(
      //   "get-unread-message",
      //   this.state.userId,
      //   "customer",
      //   (res) => {
      //     commit("set_get_count_chat", res.total_unread);
      //     // this.state.countChat = res.total_unread;
      //     // console.log(this.state.userId, res.total_unread);
      //   }
      // );
    },

    async get_user({ commit }) {
      if (!localStorage.getItem("token")) {
        return "";
      }
      try {
        let response = await axios.get("user/profile/seller");

        if (typeof response.data.data === "undefined") {
          localStorage.removeItem("token");
        } else {
          console.log(response.data.data);
          commit("set_user", response.data.data);
          this.state.userId = response.data.data.id;
        }
      } catch (error) {
        this.state.errorState = `<br/> Jika alamat sudah benar, ada beberapa hal yang bisa di coba:
        <div class="ml-4">
        <br/> &#9864; Coba beberapa saat lagi.
        <br/> &#9864; Cek koneksi internet anda.
        </div> 
        `;
        // this.state.errorState = error;
        // alert(error);

        // commit("reset_user");
        // removeHeaderToken();
        // localStorage.removeItem("token");
        return error;
      }
    },

    async get_order({ commit }) {
      if (!localStorage.getItem("token")) {
        return "";
      }
      try {
        let response = await axios.get(
          "seller/order?page=1&limit=100&filter_status=0&sort=&keyword="
        );
        // console.log(response.data.data);
        commit("set_order", response.data.data);
      } catch (error) {
        return error;
      }
    },

    async get_notif({ commit }) {
      if (!localStorage.getItem("token")) {
        return "";
      }
      try {
        let response = await axios.get(
          "user/notification/seller?page=1&limit=10&filter_type=all&filter_date="
        );
        // console.log(response.data.data);
        commit("set_notif", response.data.data);
      } catch (error) {
        return error;
      }
    },

    logout({ commit }) {
      return new Promise((resolve) => {
        axios.post("user/logout/seller");
        commit("reset_user");
        localStorage.removeItem("token");
        // localStorage.removeItem("recentStatusFilterOrder");
        removeHeaderToken();
        resolve();
      });
    },
  },
};
